import {ApolloClient, gql, InMemoryCache} from "@apollo/client";
import {API_URL} from "../src/constants/constants";


const defaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
}

const client = new ApolloClient({
    uri: API_URL,
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions,
});

export const allSaleTransactions = async (saleAddress) => {
  const saleTransactionMetaQuery = `query {
saleTransactions (where: {saleContractAddress: "${saleAddress}"}, orderBy: timestamp, orderDirection: desc) {
        __typename
        timestamp
        sender
      transactionHash
        saleContract {
        cooldownDuration
          token {
            id
            name
            decimals
            symbol
          }
          reserve {
            id
            name
            decimals
            symbol
          }
        }
        receipt {
          id
          receiptId
          fee
          units
          price
          feeRecipient
        }
        ... on SaleBuy {
          refunded
          totalIn
        }
        ... on SaleRefund {
          totalOut
        }
      }
    }`

  return client.query({
      query: gql`${saleTransactionMetaQuery}`
  });
}

export const getSaleTransactionMetaService = async (saleContactAddress, sender) => {
    const saleTransactionMetaQuery = `query {
  saleTransactions (where: {saleContractAddress: "${saleContactAddress}", sender: "${sender}"}, orderBy: timestamp, orderDirection: desc) {
          __typename
          timestamp
    	  transactionHash
          saleContract {
          cooldownDuration
            token {
              id
              name
              decimals
              symbol
            }
            reserve {
              id
              name
              decimals
              symbol
            }
          }
          receipt {
            id
            receiptId
            fee
            units
            price
            feeRecipient
          }
          ... on SaleBuy {
            refunded
            totalIn
          }
          ... on SaleRefund {
            totalOut
          }
        }
      }`

    return client.query({
        query: gql`${saleTransactionMetaQuery}`
    });
}
